import React, { useState } from 'react';

// Diccionario de descripciones
const descripciones = {
  'BOTOX': `Es un tratamiento estético que se utiliza para suavizar líneas de expresión...`,
  'ACIDO HIALURONICO': `Se utiliza para rellenar arrugas y surcos, aportando volumen...`,
  'HIDROXIAPAITA DE CALCIO': `Los bioestimuladores de colágeno estimulan la producción natural...`,
  'AQUA FINE GOLD TOUCH': `Este tratamiento mínimamente invasivo utiliza un dispositivo de microagujas...`,
  'DEPILACIÓN LÁSER': `La depilación láser ofrece varios beneficios, como una piel más suave y lisa...`,
  'LÁSER CO2': `El láser de CO2 está indicado principalmente para pacientes significativamente afectados...`,
  'ELIMINACIÓN DE TATUAJE': `La eliminación de tatuajes mediante láser es una técnica innovadora...`,
  'BLACK PEEL': `El "black peel" o peeling de carbón es un tratamiento facial que utiliza carbón activado...`,
  'EMSCULPT': `El Emsculpt utiliza ondas electromagnéticas de alta intensidad...`,
  'ÁCIDO DESOXICÓLICO': `Este tratamiento descompone las células grasas...`,
  'RUTINEL': `Es un producto de mesoterapia multitarea que se puede utilizar para tratar...`,
  'MASAJES REDUCTIVOS': `Los masajes estimulan la circulación y el drenaje linfático...`,
  'HIFU': `Ultrasonido Focalizado de Alta Intensidad, es una técnica no invasiva que utiliza ultrasonido...`,
};

const Modal = ({ open, onClose, title, description }) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40 px-4">
      <div className="bg-white p-6 rounded-lg shadow-lg max-w-xl w-full relative">
        <button onClick={onClose} className="absolute top-3 right-4 text-gray-500 text-xl">&times;</button>
        <h2 className="text-2xl font-serif text-primary mb-4">{title}</h2>
        <p className="text-gray-700 whitespace-pre-line">{description}</p>
      </div>
    </div>
  );
};

const Servicios = () => {
  const [selectedServicio, setSelectedServicio] = useState(null);
  const [isModalOpen, setModalOpen] = useState(false);

  const abrirModal = (titulo) => {
    setSelectedServicio(titulo);
    setModalOpen(true);
  };

  const cerrarModal = () => {
    setSelectedServicio(null);
    setModalOpen(false);
  };

  return (
    <section id="servicios" className="py-8 bg-[#fdf9f8] px-4 text-center">
      <h2 className="text-3xl md:text-4xl font-serif text-primary mb-12">Nuestros Servicios</h2>

      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-10 text-left">
        {/* Tratamientos Estéticos */}
        <div>
          <h3 className="text-xl font-serif text-dark mb-3 border-b border-primary inline-block">Tratamientos Estéticos</h3>
          <ul className="text-gray-700 list-disc list-inside leading-relaxed mt-2">
            {['BOTOX', 'ACIDO HIALURONICO', 'HIDROXIAPAITA DE CALCIO', 'AQUA FINE GOLD TOUCH'].map(item => (
              <li key={item}>
                <button onClick={() => abrirModal(item)} className="hover:text-primary transition">{item}</button>
              </li>
            ))}
          </ul>
        </div>

        {/* Tratamientos Láser */}
        <div>
          <h3 className="text-xl font-serif text-dark mb-3 border-b border-primary inline-block">Tratamientos Láser</h3>
          <ul className="text-gray-700 list-disc list-inside leading-relaxed mt-2">
            {['DEPILACIÓN LÁSER', 'LÁSER CO2', 'ELIMINACIÓN DE TATUAJE', 'BLACK PEEL'].map(item => (
              <li key={item}>
                <button onClick={() => abrirModal(item)} className="hover:text-primary transition">{item}</button>
              </li>
            ))}
          </ul>
        </div>

        {/* Tratamientos Corporales */}
        <div>
          <h3 className="text-xl font-serif text-dark mb-3 border-b border-primary inline-block">Tratamientos Corporales</h3>
          <ul className="text-gray-700 list-disc list-inside leading-relaxed mt-2">
            {['EMSCULPT', 'ÁCIDO DESOXICÓLICO', 'RUTINEL', 'MASAJES REDUCTIVOS', 'HIFU'].map(item => (
              <li key={item}>
                <button onClick={() => abrirModal(item)} className="hover:text-primary transition">{item}</button>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <Modal
        open={isModalOpen}
        onClose={cerrarModal}
        title={selectedServicio}
        description={descripciones[selectedServicio] || 'Información próximamente...'}
      />
    </section>
  );
};

export default Servicios;
